import React from 'react';
export function Footer() {
  return <footer className="w-full bg-off-white px-5 py-10" data-id="element-86" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-2xl text-center" data-id="element-87" data-mp="3gfsmebmgesmg">
        <p className="font-serif-display text-base font-semibold text-slate" data-id="element-88" data-mp="3ggk88uq91bzj">
          Sistema Nutri-Pro Completo™
        </p>
        <p className="mt-2 text-xs leading-relaxed text-slate/50" data-id="element-89" data-mp="36pfutzg81z6t">
          Sistema digital de consulta nutricional para profesionales de toda LATAM. Descarga
          inmediata · Pago único · Garantía de 7 días.
        </p>
        <p className="mt-4 text-xs text-slate/40" data-id="element-90" data-mp="38zbay6h7b62">
          © {new Date().getFullYear()} Sistema Nutri-Pro Completo™. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}